import React from "react";
import './Home.css'


function Wearehere() {

  return (
    <div style={{backgroundColor:'#F9FAFB'}} className="px-8 py-16 space-y-24 md:mt-[270vh] mt-[38vh]">



      {/* Content Section */}
       <div  style={{backgroundColor:'#F9FAFB'}} className="py-16 px-6 md:px-10 flex justify-center bg-white">
      <div className="max-w-3xl text-gray-700 text-[16px] leading-8 font-inter">
        <p className="mb-8 text-left poppin">
          <strong>BrandMount The Identity Expert Pvt Ltd</strong> is a full-service branding agency committed to transforming businesses and individuals into industry leaders. We believe that branding is not just about aesthetics—it is about creating an identity that resonates with audiences, builds credibility, and drives success.
        </p>
        <p className="text-left poppin">
          By combining modern branding techniques, digital marketing, legal expertise, and strategic storytelling, we help businesses craft identities that adapt to evolving market trends and sustain long-term growth. Our collaborative approach ensures that every client receives tailored branding solutions that align with their vision, mission, and business objectives.
        </p>
      </div>
    </div>


    </div>
  );
}

export default Wearehere;
